import React, { useEffect, useState, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './Oranlar.css'; // Import the new CSS file

const Oranlar = () => {
    const [isLoggedIn, setIsLoggedIn] = useState(localStorage.getItem('isLoggedIn') === 'true');
    const navigate = useNavigate();

    useEffect(() => {
        const storedIsLoggedIn = localStorage.getItem('isLoggedIn') === 'true';
        setIsLoggedIn(storedIsLoggedIn);

        if (!storedIsLoggedIn) {
            navigate('/login');
        }
    }, [navigate]);

    return (
        <div>
            {/* Breadcrumb Section */}
            <div className="breadcrumb-section breadcrumb-bg">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8 offset-lg-2 text-center">
                            <div className="breadcrumb-text">
                                <p>Detaylı Analizler</p>
                                <h1>Oranlar ve İstatistikler</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Main Content Section */}
            <div className="oranlar-container">
                <div className="container">
                    <div className="section-title text-center mb-5">
                        <h3><span className="orange-text">Hangi</span> Analizi Yapmak İstersiniz?</h3>
                        <p>Aşağıdaki seçeneklerden size uygun olan analiz türünü seçerek detaylı istatistiklere ulaşabilirsiniz.</p>
                    </div>

                    <div className="oran-grid">
                        <Link to="/acilisoran" className="oran-card">
                            <div className="card-icon-wrapper">
                                <i className="fas fa-door-open card-icon"></i>
                            </div>
                            <h4 className="card-title">Açılış Oranları</h4>
                            <p className="card-description">Maçların ilk açılan oranlarını inceleyin ve analiz yapın.</p>
                        </Link>

                        <Link to="/kapanisoran" className="oran-card">
                            <div className="card-icon-wrapper">
                                <i className="fas fa-door-closed card-icon"></i>
                            </div>
                            <h4 className="card-title">Kapanış Oranları</h4>
                            <p className="card-description">Maçların kapanış oranlarına göre detaylı filtreleme yapın.</p>
                        </Link>

                        <Link to="/yabanciacilis" className="oran-card">
                            <div className="card-icon-wrapper">
                                <i className="fas fa-globe-americas card-icon"></i>
                            </div>
                            <h4 className="card-title">Yabancı Açılış</h4>
                            <p className="card-description">Yurt dışı bürolarının açılış oranlarını karşılaştırın.</p>
                        </Link>

                        <Link to="/yabancikapanis" className="oran-card">
                            <div className="card-icon-wrapper">
                                <i className="fas fa-globe-europe card-icon"></i>
                            </div>
                            <h4 className="card-title">Yabancı Kapanış</h4>
                            <p className="card-description">Yurt dışı kaynaklı kapanış oranları ile stratejinizi belirleyin.</p>
                        </Link>

                        <Link to="/yerelkapanis" className="oran-card">
                            <div className="card-icon-wrapper">
                                <i className="fas fa-map-marker-alt card-icon"></i>
                            </div>
                            <h4 className="card-title">Yerel Kapanış</h4>
                            <p className="card-description">Yerel ligler ve özel kapanış oranları analizleri.</p>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Oranlar;
